module.exports = __webpack_public_path__ + "media/images/athletes/2113-99c5529f8c3e689a173b4ceefebf726f.png";